import React from 'react';
import { Icon, Tooltip } from '@wfp/ui';
import { iconCheckmarkOutline, iconCloseOutline } from '@wfp/icons';

import { formatDate } from '../../utils/utils';
import { WarningEvent, WarningEventStatus, warningEventStatusLabel } from '../../restapi/types';


interface Props {
	event: WarningEvent;
}

const iconCircleOutline = <svg width="16" height="16" viewBox="0 0 16 16">
	<path
		d="M8 14.5c3.6 0 6.5-2.9 6.5-6.5S11.6 1.5 8 1.5 1.5 4.4 1.5 8s2.9 6.5 6.5 6.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"/>
</svg>;

export const warningEventStatusIcon = {
	[WarningEventStatus.draft]: iconCircleOutline,
	[WarningEventStatus.approved]: iconCheckmarkOutline,
	[WarningEventStatus.reopen]: iconCloseOutline,
};

export const warningEventStatusColor = {
	[WarningEventStatus.draft]: '#0002',
	[WarningEventStatus.approved]: '#008868',
	[WarningEventStatus.reopen]: '#c5192d',
};

export function ApprovedMark({event}: Props) {
	const label = <div><p className="no-wrap">{warningEventStatusLabel[event.status]} {
		(event.status === WarningEventStatus.approved) ?
			<>on<br/>{formatDate(event.approvedOn!)}</> : ''}</p></div>;

	return <div className="approved-mark">
		<Tooltip dark trigger="hover" placement="top"
				 createRefWrapper={true}
				 content={label}>
			<Icon fill={warningEventStatusColor[event.status]}
				  icon={warningEventStatusIcon[event.status]}
				  description=""/>
		</Tooltip>
	</div>;

}